import type { TranslationKey } from "./en";

const pt: Partial<Record<TranslationKey, string>> = {
  "lang.label": "Idioma",
  "lang.select": "Selecionar idioma",
  "theme.toggle": "Alternar tema",
  "theme.light": "Modo claro",
  "theme.dark": "Modo escuro",
  "brand.name": "GuardAI by G-Data Labs",
  "brand.short": "GuardAI",
  "brand.subtitle": "Ronda de Segurança",
  "brand.guardSystem": "Sistema de Vigilância",
  "console.director": "Console do Diretor",
  "console.admin": "Console de Administração",
  "console.supervisor": "Console do Supervisor",
  "role.administrator": "Administrador",
  "role.director": "Diretor",
  "role.supervisor": "Supervisor",
  "role.guard": "Vigilante",
  "nav.dashboard": "Painel",
  "nav.liveActivity": "Atividade ao Vivo",
  "nav.devices": "Dispositivos",
  "nav.schedules": "Escalas",
  "nav.calendar": "Calendário",
  "nav.alerts": "Alertas",
  "nav.checkpoints": "Pontos de controlo",
  "nav.reports": "Relatórios",
  "nav.reportBuilder": "Criador de Relatórios",
  "nav.askAi": "Perguntar à IA",
  "nav.admin": "Administração",
  "nav.settings": "Configurações",
  "nav.deploy": "Implantação",
  "nav.scanMap": "Mapa de Leituras",
  "nav.users": "Gestão de Usuários",
  "common.save": "Salvar",
  "common.cancel": "Cancelar",
  "common.submit": "Enviar",
  "common.delete": "Excluir",
  "common.edit": "Editar",
  "common.search": "Pesquisar",
  "common.filter": "Filtrar",
  "common.export": "Exportar",
  "common.clear": "Limpar",
  "common.viewAll": "Ver tudo",
  "common.back": "Voltar",
  "common.close": "Fechar",
  "common.confirm": "Confirmar",
  "common.add": "Adicionar",
  "common.refresh": "Atualizar",
  "common.loading": "Carregando…",
  "common.saving": "Salvando…",
  "common.saved": "Salvo",
  "common.error": "Erro",
  "common.noData": "Sem dados",
  "common.required": "Obrigatório",
  "common.optional": "Opcional",
  "common.yes": "Sim",
  "common.no": "Não",
  "common.all": "Todos",
  "common.none": "Nenhum",
  "common.name": "Nome",
  "common.status": "Status",
  "common.location": "Local",
  "common.time": "Hora",
  "common.date": "Data",
  "common.actions": "Ações",
  "common.today": "hoje",
  "domain.scanEvent": "Evento de leitura",
  "domain.scanEvents": "Eventos de leitura",
  "domain.checkpoint": "Ponto de controle",
  "domain.checkpoints": "Pontos de controle",
  "domain.hospital": "Hospital",
  "domain.hospitals": "Hospitais",
  "domain.guard": "Vigilante",
  "domain.guards": "Vigilantes",
  "domain.device": "Dispositivo",
  "domain.devices": "Dispositivos",
  "domain.patrol": "Ronda",
  "domain.security": "Segurança",
  "domain.shift": "Turno",
  "domain.station": "Estação",
  "search.placeholder": "Pesquisar vigilantes, locais ou leituras…",
  "notif.title": "Notificações",
  "notif.empty": "Nenhuma notificação nova",
  "notif.viewAll": "Ver Todas as Notificações",
  "notif.missedCheckpoint": "Alerta de Ponto de Controle Não Verificado",
  "status.active": "Ativo",
  "status.inactive": "Inativo",
  "status.online": "Online",
  "status.offline": "Offline",
  "status.pending": "Pendente",
  "status.approved": "Aprovado",
  "status.denied": "Negado",
  "status.flagged": "Sinalizado",
  "status.completed": "Concluído",
  "status.missed": "Não verificado",
  "status.onDuty": "Em Serviço",
  "status.offDuty": "Fora de Serviço",
  "auth.signIn": "Entrar",
  "auth.signingIn": "Entrando…",
  "auth.signOut": "Sair",
  "auth.username": "Usuário",
  "auth.password": "Senha",
  "auth.loginFailed": "Falha no login",
  "auth.tagline": "Os vigilantes leem o crachá em qualquer estação e os supervisores veem as atualizações instantaneamente em um painel seguro.",
  "dashboard.title": "Central de Ronda de Segurança",
  "dashboard.subtitle": "Monitoramento em tempo real de todos os pontos de controle",
  "dashboard.totalScans": "Total de Leituras",
  "dashboard.activeGuards": "Vigilantes Ativos",
  "dashboard.checkpoints": "Pontos de Controle",
  "dashboard.openAlerts": "Alertas Abertos",
  "dashboard.recentActivity": "Atividade Recente",
  "dashboard.noActivity": "Nenhuma atividade recente",
  "live.title": "Atividade de Ronda ao Vivo",
  "live.subtitle": "Um feed em tempo real de cada leitura de crachá conforme acontece",
  "live.empty": "Nenhuma atividade ainda",
  "live.waiting": "Aguardando a próxima leitura…",
  "devices.title": "Dispositivos de Ronda Conectados",
  "devices.subtitle": "Status de cada dispositivo de leitura em campo",
  "devices.lastSeen": "Visto por último",
  "devices.battery": "Bateria",
  "devices.none": "Nenhum dispositivo conectado",
  "schedules.title": "Escalas de Ronda",
  "schedules.subtitle": "Atribua vigilantes a turnos e pontos de controle",
  "schedules.addShift": "Adicionar Turno",
  "schedules.none": "Nenhuma escala ainda",
  "alerts.title": "Alertas de Segurança",
  "alerts.subtitle": "Pontos de controle não verificados e eventos sinalizados que exigem atenção",
  "alerts.none": "Nenhum alerta ativo",
  "alerts.allClear": "Tudo certo — nada exige atenção.",
  "alerts.acknowledge": "Reconhecer",
  "alerts.resolve": "Resolver",
  "reports.title": "Relatórios de Segurança",
  "reports.subtitle": "Cobertura de ronda, volume de leituras e análise de integridade",
  "reports.builderTitle": "Criador de Relatórios",
  "reports.builderSubtitle": "Crie relatórios profissionais — sem necessidade de programação.",
  "reports.generate": "Gerar Relatório",
  "reports.noData": "Sem dados para este relatório",
  "ask.title": "Perguntar à IA",
  "ask.greeting": "Como posso ajudar você hoje?",
  "ask.placeholder": "Pergunte qualquer coisa sobre suas rondas, vigilantes ou leituras…",
  "ask.send": "Enviar",
  "ask.thinking": "Pensando…",
  "admin.title": "Administração do Sistema",
  "admin.subtitle": "Gerencie acessos, aprovações e a saúde do sistema",
  "admin.pendingApplications": "Solicitações Pendentes",
  "admin.systemHealth": "Saúde do Sistema",
  "admin.uptime": "Tempo de Atividade",
  "admin.storage": "Armazenamento",
  "admin.users": "Usuários",
  "admin.latency": "Latência",
  "users.title": "Gestão de Usuários",
  "users.subtitle": "Adicione, edite e desative contas da plataforma",
  "users.addUser": "Adicionar Usuário",
  "users.none": "Nenhum usuário encontrado",
  "settings.title": "Configurações",
  "settings.subtitle": "Gerencie sua conta e preferências",
  "settings.account": "Conta",
  "settings.appearance": "Aparência",
  "settings.notifications": "Notificações",
  "settings.language": "Idioma",
  "deploy.title": "Planejador de Implantação",
  "deploy.subtitle": "Planeje, registre e verifique o posicionamento dos pontos de controle",
  "deploy.plan": "Planejar",
  "deploy.capture": "Registrar",
  "deploy.verify": "Verificar",
  "map.title": "Mapa de Leituras",
  "map.subtitle": "Onde as leituras de crachá estão ocorrendo nas instalações",
  "map.noScans": "Nenhuma leitura para exibir",
  "profile.account": "Conta",
  "profile.settings": "Configurações",
  "profile.help": "Ajuda e Suporte",
  "profile.darkMode": "Modo Escuro",
  "profile.viewProfile": "Ver perfil",
  "footer.copyright": "© 2026 G-Data Labs. Todos os direitos reservados.",
  "footer.terms": "Termos de Uso",
  "footer.privacy": "Política de Privacidade",
  // ── Auto-added: full dashboard content translations ──
  "admin.addGuard": "Adicionar guarda",
  "admin.addNewGuard": "Adicionar novo guarda",
  "admin.addRoute": "Adicionar rota",
  "admin.alertEmail": "E-mail de notificação de alertas",
  "admin.avgResponse": "Resposta média",
  "admin.checkpointTimeout": "Tempo limite do ponto de verificação (minutos)",
  "admin.checkpointsCount": "Pontos de verificação ({n})",
  "admin.colBadge": "Crachá",
  "admin.colContact": "Contato",
  "admin.colGuard": "Guarda",
  "admin.colLastActive": "Última atividade",
  "admin.colRole": "Função",
  "admin.colRoutes": "Rotas",
  "admin.deactivatedPreviewDesc": "É assim que uma conta desativada aparece para os administradores.",
  "admin.deactivatedPreviewTitle": "Visualização de guarda desativado",
  "admin.difficultyEasy": "Fácil",
  "admin.difficultyHard": "Difícil",
  "admin.difficultyMedium": "Média",
  "admin.employeeId": "ID do funcionário:",
  "admin.errorAddGuard": "Não foi possível adicionar o guarda. Tente novamente.",
  "admin.errorAllFields": "Todos os campos são obrigatórios.",
  "admin.errorLoadDirectory": "Não foi possível carregar o diretório de guardas no momento.",
  "admin.fieldEmail": "E-mail",
  "admin.fieldEmergencyContact": "Contato de emergência",
  "admin.fieldEmployeeId": "ID de funcionário Emory",
  "admin.fieldFullName": "Nome completo",
  "admin.fieldPhone": "Telefone",
  "admin.fieldRole": "Função",
  "admin.fieldTempPassword": "Senha temporária",
  "admin.gpsThreshold": "Limite de precisão do GPS (metros)",
  "admin.guardId": "ID do guarda:",
  "admin.loadingDirectory": "Carregando o diretório de guardas…",
  "admin.moreCheckpoints": "+{n} pontos de verificação a mais",
  "admin.noGuards": "Nenhum guarda encontrado. Adicione seu primeiro guarda para começar.",
  "admin.noRoutesAssigned": "Nenhuma rota atribuída",
  "admin.notGenerated": "Não gerado",
  "admin.passwordPolicy": "Política de senhas",
  "admin.passwordPolicyDesc": "Exigir senhas fortes",
  "admin.patrolRoutes": "Rotas de patrulha",
  "admin.placeholderTempPassword": "Defina uma senha temporária",
  "admin.resetSessions": "Redefinir todas as sessões",
  "admin.roleAdmin": "Administrador",
  "admin.roleDirector": "Diretor",
  "admin.roleGuard": "Guarda",
  "admin.roleSupervisor": "Supervisor",
  "admin.saveConfiguration": "Salvar configuração",
  "admin.searchGuards": "Pesquisar guardas...",
  "admin.securitySettings": "Configurações de segurança",
  "admin.sessionTimeout": "Tempo limite da sessão",
  "admin.sessionTimeoutDesc": "Logout automático após inatividade",
  "admin.statusDeactivated": "Desativado",
  "admin.statusLabel": "Status:",
  "admin.statusSuspended": "Suspenso",
  "admin.storageUsed": "Armazenamento usado",
  "admin.systemConfiguration": "Configuração do sistema",
  "admin.systemStatus": "Status do sistema",
  "admin.tabBadges": "Gerador de crachás",
  "admin.tabGuards": "Gestão de guardas",
  "admin.tabRoutes": "Gestão de rotas",
  "admin.tabSettings": "Configurações do sistema",
  "admin.timeout1Hour": "1 hora",
  "admin.timeout2Hours": "2 horas",
  "admin.timeout30Min": "30 minutos",
  "admin.timeout4Hours": "4 horas",
  "admin.totalScans": "Total de leituras",
  "admin.twoFactor": "Autenticação de dois fatores",
  "admin.twoFactorDesc": "Exigir 2FA para todos os supervisores",
  "admin.viewBadge": "Ver crachá",
  "alerts.acknowledged": "Reconhecido",
  "alerts.activeAlerts": "Alertas ativos",
  "alerts.allLocationsHealthy": "Todos os locais em bom estado",
  "alerts.allPriorities": "Todas as prioridades",
  "alerts.allStatus": "Todos os status",
  "alerts.allTypes": "Todos os tipos",
  "alerts.apiError": "Erro de API",
  "alerts.assignedTo": "Atribuído a:",
  "alerts.critical": "Crítica",
  "alerts.distanceAway": "a {n} m",
  "alerts.exportTitle": "Exportar dados de alertas",
  "alerts.filters": "Filtros",
  "alerts.guardLabel": "Guarda {name}",
  "alerts.high": "Alta",
  "alerts.invalidScan": "Leitura inválida",
  "alerts.issuesDetected": "{n} problemas detectados",
  "alerts.loadFailed": "Falha ao carregar os alertas",
  "alerts.loadFailedHint": "verifique se o endpoint de alertas está implantado.",
  "alerts.loadingAlerts": "Carregando alertas...",
  "alerts.low": "Baixa",
  "alerts.medium": "Média",
  "alerts.noInvalidScans": "Nenhuma leitura inválida no último lote.",
  "alerts.noneMatchFilters": "Nenhum alerta encontrado correspondente aos seus filtros",
  "alerts.refreshTitle": "Atualizar alertas",
  "alerts.resolved": "Resolvido",
  "alerts.scanExceptions": "Exceções de leitura da patrulha",
  "alerts.scanExceptionsSubtitle": "Leituras inválidas ou erros de API provenientes dos dispositivos de campo",
  "alerts.tryAgain": "Tentar novamente",
  "alerts.typeEmergency": "Emergência",
  "alerts.typeMissedCheckpoint": "Ponto de verificação perdido",
  "alerts.typeSystem": "Sistema",
  "alerts.unknownGuard": "desconhecido",
  "ask.accessDenied": "Acesso negado",
  "ask.accessDeniedDesc": "O recurso Perguntar à IA é restrito a administradores.",
  "ask.askNow": "Perguntar agora",
  "ask.askedTimesOne": "Perguntado {n} vez",
  "ask.askedTimesOther": "Perguntado {n} vezes",
  "ask.closeHistory": "Fechar histórico",
  "ask.dateAtTime": "{date} às {time}",
  "ask.encryptedPrivate": "Análise criptografada e privada",
  "ask.errorMessage": "Desculpe, não consegui processar essa pergunta. Isso pode ser devido a um problema de conexão ou a uma consulta não suportada. Tente reformular sua pergunta ou tente novamente em instantes.",
  "ask.exampleInvalidScans": "Quais locais registraram mais leituras INVÁLIDAS esta semana?",
  "ask.exampleMissedScans": "Mostre os guardas que perderam 3 ou mais leituras nos últimos 7 dias.",
  "ask.exampleNoScansToday": "Liste os locais que não receberam nenhuma leitura hoje.",
  "ask.exampleOvernightScans": "Quantas leituras foram registradas durante a noite, entre 22:00 e 06:00?",
  "ask.frequentlyAsked": "Perguntas frequentes",
  "ask.hideSql": "Ocultar consulta SQL",
  "ask.history": "Histórico",
  "ask.inputPlaceholder": "Pergunte algo como “Quais locais tiveram menos leituras ontem?”",
  "ask.noHistory": "Ainda não há histórico. Faça uma pergunta para começar.",
  "ask.noQueriesMatching": "Nenhuma consulta corresponde a \"{q}\"",
  "ask.rowCountOne": "{n} linha",
  "ask.rowCountOther": "{n} linhas",
  "ask.searchPlaceholder": "Pesquisar consultas anteriores...",
  "ask.showSql": "Mostrar consulta SQL",
  "ask.subtitle": "Pergunte sobre conformidade de patrulhas, pontos de verificação perdidos, desempenho dos guardas ou tendências por local.",
  "ask.tagline": "Baseado em dados de patrulha em tempo real",
  "ask.thisWeek": "Esta semana",
  "ask.today": "Hoje",
  "ask.yesterday": "Ontem",
  "auth.applyToJoin": "Candidate-se para entrar na nossa equipe",
  "auth.email": "E-mail",
  "auth.enterCredentials": "Insira suas credenciais para acessar o sistema.",
  "auth.needAccess": "Precisa de acesso ao sistema de segurança?",
  "deploy.addFloor": "+ Andar",
  "deploy.addUnplannedCheckpoint": "Adicionar ponto de verificação não planejado",
  "deploy.address": "Endereço",
  "deploy.allSaved": "Tudo salvo",
  "deploy.area": "Área",
  "deploy.areaDescription": "Área / descrição",
  "deploy.areaLabel": "Área:",
  "deploy.areaPlaceholder": "Entrada do PS, Suíte administrativa 200…",
  "deploy.areaSuite": "Área / Suíte",
  "deploy.cameraError": "Erro de câmera:",
  "deploy.cancelScan": "Cancelar leitura",
  "deploy.captureWalkthrough": "Percurso de captura",
  "deploy.capturedProgress": "{done} / {total} capturados",
  "deploy.checkpointsCount": "Pontos de verificação ({n})",
  "deploy.ckStatusCaptured": "capturado",
  "deploy.ckStatusInstalled": "instalado",
  "deploy.ckStatusPlanned": "planejado",
  "deploy.ckStatusVerified": "verificado",
  "deploy.clickAnywhereToPlace": "Clique em qualquer lugar para colocar o marcador",
  "deploy.clickFloorPlan": "Clique na planta baixa…",
  "deploy.complete": "Concluído!",
  "deploy.completionReport": "Relatório de conclusão",
  "deploy.contactLabel": "Contato:",
  "deploy.contactPhone": "Telefone de contato",
  "deploy.createAndCapture": "Criar e capturar",
  "deploy.createProject": "Criar projeto",
  "deploy.creating": "Criando…",
  "deploy.dismiss": "descartar",
  "deploy.editingCheckpoint": "Editando ponto de verificação",
  "deploy.fileFormats": "PNG, JPG ou PDF",
  "deploy.floor": "Andar",
  "deploy.floorColon": "Andar:",
  "deploy.floorLabel": "Andar:",
  "deploy.floorN": "Andar {n}",
  "deploy.floorPlanAlt": "Planta do andar {n}",
  "deploy.generated": "Gerado:",
  "deploy.gettingGps": "Obtendo GPS…",
  "deploy.gpsFailedRetry": "Falha no GPS — tentar novamente",
  "deploy.grabGps": "Capturar GPS",
  "deploy.hospitalNameRequired": "Nome do hospital *",
  "deploy.initials": "Iniciais: ______",
  "deploy.installVerify": "Instalar e verificar",
  "deploy.installedAlt": "instalado",
  "deploy.installedVerifiedProgress": "{done} / {total} instalados e verificados",
  "deploy.locationDetail": "Detalhe da localização",
  "deploy.locationDetailPlaceholder": "À esquerda das portas principais, acima do álcool em gel…",
  "deploy.locationDetailShort": "À esquerda das portas principais…",
  "deploy.locationLabel": "Localização:",
  "deploy.markInstalledVerified": "Marcar como instalado e verificado",
  "deploy.newCheckpoint": "Novo ponto de verificação",
  "deploy.newDeploymentProject": "Novo projeto de implantação",
  "deploy.newProject": "Novo projeto",
  "deploy.newUnplannedCheckpoint": "Novo ponto de verificação não planejado",
  "deploy.noCameraFound": "Nenhuma câmera encontrada",
  "deploy.noCheckpointsHint": "Clique em \"Colocar marcador\" e depois na planta baixa.",
  "deploy.noCheckpointsYet": "Ainda não há pontos de verificação.",
  "deploy.noProjectSelected": "Nenhum projeto selecionado",
  "deploy.noProjectSelectedHint": "Selecione um projeto existente ou crie um novo acima.",
  "deploy.noProjectsYet": "Ainda não há projetos.",
  "deploy.notYetVerified": "Ainda não verificados",
  "deploy.notes": "Notas",
  "deploy.notesLabel": "Notas:",
  "deploy.notesPlaceholder": "Notas de referência, detalhes de montagem…",
  "deploy.placeCardHere": "Coloque o cartão AQUI (da captura):",
  "deploy.placeMarker": "Colocar marcador",
  "deploy.placementNotes": "Notas de colocação",
  "deploy.placementNotesPlaceholder": "1,5 m de altura, parede de tijolos, adesivo permanente…",
  "deploy.placementReferenceAlt": "referência de colocação",
  "deploy.print": "Imprimir",
  "deploy.printChecklist": "Imprimir lista de verificação",
  "deploy.qrPlaced": "QR colocado",
  "deploy.qrPrefix": "QR:",
  "deploy.recapture": "Recapturar",
  "deploy.retakeInstalledPhoto": "Tirar foto da instalação novamente",
  "deploy.retakePhoto": "Tirar foto novamente",
  "deploy.reverify": "Verificar novamente",
  "deploy.saveCapture": "Salvar captura",
  "deploy.scanAgain": "Escanear novamente",
  "deploy.scanQrCode": "Escanear código QR",
  "deploy.scanToVerify": "Escanear para verificar",
  "deploy.scanVerified": "Leitura verificada",
  "deploy.scannedPrefix": "Lido:",
  "deploy.selectProject": "Selecionar um projeto…",
  "deploy.selectProjectShort": "Selecionar projeto…",
  "deploy.selectProjectToCapture": "Selecione um projeto para começar a capturar.",
  "deploy.selectProjectToVerify": "Selecione um projeto para começar a verificar.",
  "deploy.simulation3d": "Simulação 3D",
  "deploy.siteContactName": "Nome do contato do local",
  "deploy.speechNotSupported": "O reconhecimento de voz não é compatível com este navegador.",
  "deploy.statusCapturing": "captura",
  "deploy.statusComplete": "concluído",
  "deploy.statusFabricating": "fabricação",
  "deploy.statusInstalling": "instalação",
  "deploy.statusPlanning": "planejamento",
  "deploy.stop": "Parada",
  "deploy.stopNumber": "Parada nº {n}",
  "deploy.stopVoice": "Parar",
  "deploy.takeInstalledPhoto": "Tirar foto da instalação",
  "deploy.takePhoto": "Tirar foto",
  "deploy.total": "Total",
  "deploy.unnamed": "Sem nome",
  "deploy.unnamedLower": "sem nome",
  "deploy.unsavedChanges": "Alterações não salvas...",
  "deploy.uploadFloorPlan": "Carregar planta baixa",
  "deploy.uploadFloorPlanFor": "Carregue uma planta para o andar {n}",
  "deploy.uuidMatched": "UUID corresponde! QR verificado.",
  "deploy.uuidMismatch": "UUID não corresponde. Cartão QR incorreto.",
  "deploy.uuidPrefix": "UUID:",
  "deploy.verifiedCheckpoints": "Pontos de verificação verificados",
  "deploy.verifiedCount": "Verificados",
  "deploy.voice": "Voz",
  "deploy.walkthroughChecklistStops": "Lista de verificação do percurso de implantação — {n} paradas",
  "devices.appVersion": "Versão do app",
  "devices.deviceManagement": "Gerenciamento de dispositivos",
  "devices.emptyHint": "Os dispositivos conectados aparecerão aqui assim que enviarem telemetria.",
  "devices.geofences": "Geocercas",
  "devices.hoursAgo": "há {n} h",
  "devices.justNow": "Agora mesmo",
  "devices.lastLocation": "Última localização",
  "devices.locateOnMap": "Localizar dispositivo no mapa",
  "devices.minutesAgo": "há {n} min",
  "devices.never": "Nunca",
  "devices.noDevicesFound": "Nenhum dispositivo encontrado",
  "devices.noGpsData": "Sem dados de GPS",
  "devices.refreshStatus": "Atualizar status",
  "devices.violations": "Violações",
  "geofence.acknowledge": "Reconhecer",
  "geofence.acknowledged": "Reconhecida",
  "geofence.acknowledging": "Reconhecendo...",
  "geofence.actionHeader": "Ação",
  "geofence.allGeofences": "Todas as geocercas",
  "geofence.create": "Criar geocerca",
  "geofence.createdBy": "Criado por",
  "geofence.createdDate": "Data de criação",
  "geofence.deleteConfirmBody": "Esta ação não pode ser desfeita. A geocerca será excluída permanentemente.",
  "geofence.deleteConfirmTitle": "Excluir geocerca?",
  "geofence.drawPolygon": "Desenhar polígono no mapa",
  "geofence.drawPolygonHint": "Clique no mapa para adicionar pontos. O polígono deve ter pelo menos 3 pontos. Pontos atuais: {n}",
  "geofence.edit": "Editar geocerca",
  "geofence.enterName": "Insira um nome para a geocerca",
  "geofence.failedCreate": "Falha ao criar a geocerca",
  "geofence.failedDelete": "Falha ao excluir a geocerca",
  "geofence.failedLoad": "Falha ao carregar as geocercas",
  "geofence.failedSave": "Falha ao salvar a geocerca",
  "geofence.failedUpdate": "Falha ao atualizar a geocerca",
  "geofence.filterByGeofence": "Filtrar por geocerca",
  "geofence.geofenceHeader": "Geocerca",
  "geofence.gpsCoordinates": "Coordenadas GPS",
  "geofence.hoursAgo": "há {n} h",
  "geofence.justNow": "Agora mesmo",
  "geofence.management": "Gerenciamento de geocercas",
  "geofence.managementSubtitle": "Defina zonas seguras e monitore violações de limite",
  "geofence.minPoints": "O polígono deve ter pelo menos 3 pontos",
  "geofence.minutesAgo": "há {n} min",
  "geofence.nameLabel": "Nome da geocerca",
  "geofence.namePlaceholder": "ex.: Entrada principal, Estacionamento A",
  "geofence.noViolations": "Nenhuma violação detectada",
  "geofence.noViolationsHint": "Todos os dispositivos estão dentro de suas geocercas designadas.",
  "geofence.noneConfigured": "Nenhuma geocerca está configurada para sua localização.",
  "geofence.noneYet": "Ainda não há geocercas",
  "geofence.noneYetCanCreate": "Crie sua primeira geocerca para começar o monitoramento de limites.",
  "geofence.pointN": "Ponto {n}:",
  "geofence.polygonPoints": "Pontos do polígono ({n})",
  "geofence.preview": "Pré-visualização",
  "geofence.save": "Salvar geocerca",
  "geofence.selectHospitalAlert": "Selecione um hospital",
  "geofence.selectHospitalOption": "Selecionar um hospital...",
  "geofence.unacknowledged": "Não reconhecida",
  "geofence.unacknowledgedCount": "{n} não reconhecidas",
  "geofence.violationsSubtitle": "Monitore e reconheça violações de limite",
  "geofence.violationsTitle": "Violações de geocerca",
  "help.callNow": "Ligar agora",
  "help.comingSoon": "Em breve",
  "help.docsComingSoon": "Documentação em breve.",
  "help.emailSupport": "Suporte por e-mail",
  "help.escalateIssue": "Escalonar problema",
  "help.guardHeadline": "Ajuda e suporte para guardas",
  "help.guidesFaq": "Guias e perguntas frequentes",
  "help.incidentEscalation": "Escalonamento de incidentes",
  "help.incidentEscalationDesc": "Relate interrupções, falhas de quiosque ou problemas urgentes de leitura.",
  "help.intro": "Entre em contato com a equipe de Patrulha de Segurança da Emory ou revise as etapas rápidas de solução de problemas.",
  "help.phoneHotline": "Linha telefônica direta",
  "help.phoneHotlineValue": "(404) 555-0199 • 24 horas por dia, 7 dias por semana",
  "help.quickTips": "Dicas rápidas",
  "help.sendEmail": "Enviar e-mail",
  "help.supervisorHeadline": "Ajuda e suporte para supervisores",
  "help.support": "Suporte",
  "help.tipAskAi": "Use a página Perguntar à IA para obter dados históricos antes de contatar o suporte.",
  "help.tipRefresh": "Atualize a página se as leituras parecerem atrasadas ou desatualizadas.",
  "help.tipReinstall": "Os guardas podem reinstalar o PWA pela página de Configurações quando o ícone desaparecer.",
  "home.activeCheckpoints": "Pontos de controle ativos",
  "home.activeCheckpointsTooltip": "Número total de locais físicos de códigos QR atualmente registrados neste hospital.",
  "home.addNewMarker": "Adicionar novo marcador",
  "home.allHospitalsAggregated": "Todos os hospitais (agregados)",
  "hospitals.allAggregated": "Todos os hospitais (agregados)",
  "home.building": "Edifício",
  "home.buildingFloor": "{building} - Andar {floor}",
  "home.cancelPlacement": "Cancelar posicionamento",
  "home.chartScans": "Leituras:",
  "home.checkpointName": "Nome do ponto de controle",
  "home.checkpointNamePlaceholder": "ex.: Finanças (Oeste)",
  "home.checkpointsScanned": "Pontos de controle lidos",
  "home.chooseCheckpoint": "— Escolha um ponto de controle —",
  "home.cleared": "LIQUIDADO",
  "home.clickToPlace": "Clique em qualquer lugar do mapa para colocar um novo marcador.",
  "home.comparingScanVolume": "Comparando o volume de leituras ativas em todos os locais registrados",
  "home.complianceRate": "Taxa de conformidade",
  "home.complianceRateTooltip": "Percentual de pontos de controle registrados que foram lidos pelo menos uma vez durante o turno atual.",
  "home.complianceRateValue": "Taxa de conformidade: {n}%",
  "home.confirmDeleteCheckpoint": "Tem certeza de que deseja excluir este ponto de controle? Esta ação não pode ser desfeita.",
  "home.createCustomCheckpoint": "+ Criar ponto de controle personalizado...",
  "home.deleteMarker": "Excluir marcador",
  "home.dragToReposition": "Arraste os marcadores para reposicionar. As alterações são salvas automaticamente.",
  "home.editModeOn": "Modo de edição ATIVADO",
  "home.editPositions": "Editar posições",
  "home.failedDeleteLocation": "Falha ao excluir o local",
  "home.failedSaveLocation": "Falha ao salvar o local",
  "home.floor": "Andar",
  "home.floorAbbr": "And. {n}",
  "home.floorN": "Andar {n}",
  "home.headerSubtitle": "Verificação de patrulha em tempo real e status de upload do hub",
  "home.hospitalPerformanceComparison": "Comparação de desempenho de hospitais",
  "home.hospitalSecurity": "Segurança do hospital",
  "home.hub": "Hub: {hub}",
  "home.internalServerError": "Erro interno do servidor",
  "home.lastHour": "Última hora",
  "home.lastScan": "Última leitura",
  "home.lastUpdated": "Última atualização:",
  "home.legendError": "Erro",
  "home.legendInvalid": "Inválido",
  "home.legendOk": "OK",
  "home.liveSystem": "Sistema ao vivo",
  "home.loadingCheckpoints": "Carregando pontos de controle...",
  "home.loadingComplianceData": "Carregando dados de conformidade...",
  "home.loadingUploads": "Carregando uploads...",
  "home.mapLast30Days": "Últimos 30 dias",
  "home.mapLast7Days": "Últimos 7 dias",
  "home.mapLastQuarter": "Último trimestre",
  "home.mapSubtitle": "Rastreamento de patrulha em tempo real e status dos pontos de controle",
  "home.mapTitle": "Mapa de atividade ao vivo do hospital",
  "home.mapTodaysScans": "Leituras de hoje",
  "home.moreCheckpoints": "+ {n} pontos de controle adicionais",
  "home.noCheckpointsConfigured": "Nenhum ponto de controle configurado para este hospital.",
  "home.noCheckpointsLoaded": "Nenhum ponto de controle carregado. Verifique a conexão com o banco de dados ou adicione um manualmente abaixo.",
  "home.noUploadsToday": "Nenhum upload registrado hoje.",
  "home.numberOfScans": "Número de leituras",
  "home.pendingClear": "LIQUIDAÇÃO PENDENTE",
  "home.placeCheckpoint": "Posicionar ponto de controle",
  "home.positionLabel": "Posição:",
  "home.qrPayload": "Carga do QR",
  "home.qrPayloadPlaceholder": "ex.: FINANCE_WEST",
  "home.recentPatrolActivity7Days": "Atividade de patrulha recente (7&nbsp;dias)",
  "home.recentScans7Days": "Leituras recentes (7&nbsp;dias)",
  "home.recentScansTooltip": "Número total de leituras de patrulha carregadas e verificadas com sucesso nos últimos 7 dias.",
  "home.registeredCheckpoints": "Pontos de controle registrados",
  "home.roleDashboard": "Painel do {role}:",
  "home.saveCheckpoint": "Salvar ponto de controle",
  "home.scanner": "Scanner: {serial}",
  "home.scansCount": "{n} leituras",
  "home.selectCheckpoint": "Selecionar ponto de controle",
  "home.tooltipPosition": "Posição",
  "home.unknownHospital": "Hospital desconhecido",
  "home.uploadsByShift": "Uploads por turno",
  "home.viewingHospital": "Hospital em exibição:",
  "landing.addressInfo": "Informações de endereço",
  "landing.agreeTerms": "Concordo com os termos de serviço",
  "landing.agreeTermsDetail": "Entendo que o acesso ao sistema de patrulha de segurança está condicionado à aprovação do supervisor e que todas as informações fornecidas são precisas e completas.",
  "landing.availableShifts": "Turnos disponíveis (selecione todos os aplicáveis)",
  "landing.bulletIntegrity": "Análises de integridade para leituras perdidas e eventos sinalizados.",
  "landing.bulletMonitoring": "Monitoramento em tempo real de cada saguão, entrada e corredor.",
  "landing.bulletWorkspace": "Espaço de trabalho unificado para supervisores com busca instantânea e insights de IA.",
  "landing.city": "Cidade",
  "landing.completeAndAgree": "Preencha todos os campos obrigatórios e concorde com os termos.",
  "landing.confirmPassword": "Confirmar senha",
  "landing.confirmYourPassword": "Confirme sua senha",
  "landing.createPassword": "Crie uma senha segura",
  "landing.dateOfBirth": "Data de nascimento",
  "landing.emailAddress": "Endereço de e-mail",
  "landing.emailRegistered": "Este endereço de e-mail já está registrado.",
  "landing.emailRegisteredUseDifferent": "Este endereço de e-mail já está registrado. Use um endereço de e-mail diferente.",
  "landing.emergencyContact": "Contato de emergência",
  "landing.emergencyContactName": "Nome do contato de emergência",
  "landing.emergencyContactPhone": "Telefone do contato de emergência",
  "landing.fillRequiredContinue": "Preencha todos os campos obrigatórios antes de continuar.",
  "landing.firstName": "Nome",
  "landing.lastName": "Sobrenome",
  "landing.next": "Próximo",
  "landing.passwordsNoMatch": "As senhas não coincidem",
  "landing.percentComplete": "{p}% concluído",
  "landing.personalInfo": "Informações pessoais",
  "landing.phoneNumber": "Número de telefone",
  "landing.phoneRegistered": "Este número de telefone já está registrado.",
  "landing.phoneRegisteredUseDifferent": "Este número de telefone já está registrado. Use um número de telefone diferente.",
  "landing.relChild": "Filho/Filha",
  "landing.relFriend": "Amigo/Amiga",
  "landing.relOther": "Outro",
  "landing.relParent": "Pai/Mãe",
  "landing.relSibling": "Irmão/Irmã",
  "landing.relSpouse": "Cônjuge",
  "landing.relationship": "Relação",
  "landing.requestAccessSubtitle": "Preencha este formulário para solicitar acesso ao sistema de patrulha de segurança.",
  "landing.requestAccessTitle": "Solicitar acesso ao sistema",
  "landing.requestSubmitted": "Solicitação de conta enviada",
  "landing.requestSubmittedApproval": "Você poderá fazer login com suas credenciais assim que for aprovado. Esse processo normalmente leva de 1 a 2 dias úteis.",
  "landing.requestSubmittedThanks": "Obrigado por solicitar acesso ao sistema de patrulha de segurança. Sua solicitação foi enviada e está aguardando aprovação dos supervisores.",
  "landing.requestedRole": "Função solicitada",
  "landing.returnHome": "Voltar ao início",
  "landing.returnToLogin": "Voltar ao login",
  "landing.roleAvailability": "Função e disponibilidade",
  "landing.securityDirector": "Diretor de segurança",
  "landing.securitySupervisor": "Supervisor de segurança",
  "landing.selectEllipsis": "Selecionar...",
  "landing.shiftDay": "Turno diurno (6h-14h)",
  "landing.shiftEvening": "Turno vespertino (14h-22h)",
  "landing.shiftHolidays": "Feriados",
  "landing.shiftNight": "Turno noturno (22h-6h)",
  "landing.shiftOnCall": "De plantão",
  "landing.shiftWeekends": "Fins de semana",
  "landing.signInSubheading": "Use suas credenciais de supervisor ou guarda para continuar.",
  "landing.signInToGuard": "Entrar no Guard",
  "landing.somethingWrong": "Algo deu errado.",
  "landing.state": "Estado",
  "landing.stepOf": "Etapa {n} de 4",
  "landing.streetAddress": "Endereço",
  "landing.submitApplication": "Enviar candidatura",
  "landing.submitFailed": "Falha ao enviar a candidatura. Tente novamente.",
  "landing.submitting": "Enviando...",
  "landing.termsOfService": "Termos de serviço",
  "landing.zipCode": "Código postal",
  "live.action": "Ação",
  "live.activityFeed": "Feed de atividades",
  "live.asOf": "Às {time}",
  "live.colCoordinate": "Coordenada",
  "live.colDateTime": "Data e hora",
  "live.colDistance": "Distância",
  "live.deviceLocation": "(Localização do dispositivo)",
  "live.filterAll": "Toda a atividade",
  "live.filterInvalid": "Leituras inválidas",
  "live.filterValid": "Leituras válidas",
  "live.floor": "Piso {n}",
  "live.freshFix": "(Posição recente)",
  "live.loadingActivity": "Carregando atividade de patrulha…",
  "live.metersAway": "a {n} m de distância",
  "live.noGpsData": "Sem dados de GPS",
  "live.noScansFilter": "Nenhuma leitura corresponde a este filtro.",
  "live.syncData": "Sincronizar dados",
  "live.timeframe": "Período",
  "live.unknownHospital": "Hospital desconhecido",
  "live.unknownLocation": "Localização desconhecida",
  "live.view3d": "Vista 3D",
  "live.view3dWorld": "Ver o mundo 3D deste ponto de controlo",
  "map.allHospitals": "Todos os hospitais",
  "map.autoRefresh": "Atualização automática",
  "map.autoRefreshTitle": "Atualização automática a cada 30s",
  "map.dark": "Escuro",
  "map.expandLegend": "Expandir legenda",
  "map.gpsDisclaimer": "As posições de leitura refletem a precisão do GPS do dispositivo. Sinais internos podem variar de 10 a 50 m em relação à localização real.",
  "map.heatmap": "Mapa de calor",
  "map.heatmapTitle": "Alternar mapa de calor de densidade",
  "map.legend": "Legenda",
  "map.light": "Claro",
  "map.limitedWarning": "O mapa exibe no máximo {max} leituras. Restrinja o intervalo de tempo ou o filtro de hospital para ver dados específicos.",
  "map.loadFailed": "Falha ao carregar as leituras",
  "map.loadingScans": "Carregando leituras…",
  "map.mapStyle": "Estilo do mapa: {name}",
  "map.markers": "Marcadores",
  "map.minimizeLegend": "Minimizar legenda",
  "map.noGpsScans": "Nenhuma leitura com marcação de GPS encontrada para este intervalo de tempo.",
  "map.pageSubtitle": "Visão geográfica ao vivo de onde ocorreram os eventos de leitura.",
  "map.pageTitle": "Mapa de Leituras GuardAI",
  "map.popupHospital": "Hospital:",
  "map.popupScanner": "Leitor:",
  "map.popupTime": "Hora:",
  "map.rangeCustom": "Intervalo personalizado",
  "map.rangeLast24h": "Últimas 24h",
  "map.rangeLast30d": "Últimos 30 dias",
  "map.rangeLast7d": "Últimos 7 dias",
  "map.rangeLastHour": "Última hora",
  "map.showingMaxScans": "Mostrando {shown} (máx.) de {total} leituras",
  "map.snapToBuilding": "Ajustar ao edifício",
  "map.snapToBuildingTitle": "Ajusta os pontos de GPS para os centros dos edifícios a fim de compensar o desvio de GPS em ambientes internos",
  "map.switchToDark": "Mudar para o mapa escuro",
  "map.switchToLight": "Mudar para o mapa claro",
  "map.to": "até",
  "map.totalScans": "{total} leituras",
  "map.unknownHospital": "Desconhecido",
  "map.updatedAt": "Atualizado {time}",
  "reportBuilder.addWidget": "Adicionar um widget",
  "reportBuilder.aiAssistant": "Assistente de relatórios com IA",
  "reportBuilder.aiPlaceholder": "Descreva o relatório que deseja — por ex. “contagem de escaneamentos por hospital no último mês com um gráfico de barras”. Ou esboce um layout no papel e envie uma foto.",
  "reportBuilder.aiSummaryHint": "Clique em “Gerar” para escrever observações a partir dos dados do seu relatório.",
  "reportBuilder.allHospitals": "Todos os hospitais",
  "reportBuilder.allTime": "Todo o período",
  "reportBuilder.assistantUnavailable": "O assistente está indisponível no momento.",
  "reportBuilder.author": "Autor",
  "reportBuilder.beta": "Beta",
  "reportBuilder.buildItForMe": "Crie para mim",
  "reportBuilder.buildTogether": "Vamos construí-lo juntos",
  "reportBuilder.canvasEmpty": "Sua tela está vazia",
  "reportBuilder.canvasEmptyHint": "Adicione um widget pela barra de ferramentas acima, clique em um campo de dados à esquerda ou comece a partir de um modelo.",
  "reportBuilder.captionPlaceholder": "Legenda (opcional)",
  "reportBuilder.color": "Cor",
  "reportBuilder.compareAgainst": "Comparar com",
  "reportBuilder.configure": "Configurar",
  "reportBuilder.copySuffix": "(cópia)",
  "reportBuilder.couldntSave": "Não foi possível salvar:",
  "reportBuilder.dataFields": "Campos de dados",
  "reportBuilder.dataFieldsHint": "Clique em qualquer campo para adicionar um widget pronto ao seu relatório.",
  "reportBuilder.dataSource": "Fonte de dados",
  "reportBuilder.dateFrom": "A partir de {date}",
  "reportBuilder.dateFromLabel": "Data de início",
  "reportBuilder.dateThrough": "Até {date}",
  "reportBuilder.dateToLabel": "Data de término",
  "reportBuilder.dayOfWeekOpt": "Dia da semana",
  "reportBuilder.describeOrSketch": "Descreva o relatório que deseja ou anexe um esboço.",
  "reportBuilder.dismiss": "Dispensar",
  "reportBuilder.done": "Concluído",
  "reportBuilder.donutStyle": "Estilo rosca",
  "reportBuilder.draftedOffline": " · rascunhado offline",
  "reportBuilder.duplicate": "Duplicar",
  "reportBuilder.example1": "Contagem de escaneamentos por hospital no último mês, com um gráfico de barras",
  "reportBuilder.example2": "Atividade de patrulha diária com horários de pico e dispositivos ativos",
  "reportBuilder.example3": "Cobertura de pontos de verificação: verificados vs. não verificados por hospital",
  "reportBuilder.exportCsv": "CSV (dados)",
  "reportBuilder.exportFailed": "Falha na exportação:",
  "reportBuilder.exportHtml": "HTML (compartilhável)",
  "reportBuilder.exportPdf": "PDF (pronto para impressão)",
  "reportBuilder.exportPng": "Imagem PNG",
  "reportBuilder.exportPrint": "Imprimir",
  "reportBuilder.exportSlides": "Pronto para slides (HTML)",
  "reportBuilder.exportTryPdf": "Tente PDF (Imprimir) em vez disso.",
  "reportBuilder.exportXls": "Excel (.xls)",
  "reportBuilder.fieldTitle": "Título",
  "reportBuilder.filterFloor": "Filtro: andar",
  "reportBuilder.filterHospital": "Filtro: hospital",
  "reportBuilder.floorPlaceholder": "ex. L1, 5, Plaza",
  "reportBuilder.generate": "Gerar",
  "reportBuilder.generateBtn": "Gerar",
  "reportBuilder.generatedBy": "Gerado pela GuardAI · © {year} G-Data Labs. Todos os direitos reservados.",
  "reportBuilder.generating": "Gerando…",
  "reportBuilder.group": "Grupo",
  "reportBuilder.groupBy": "Agrupar por",
  "reportBuilder.hideSettings": "Ocultar configurações",
  "reportBuilder.horizontal": "horizontal",
  "reportBuilder.imageTooLarge": "Essa imagem é um pouco grande — use uma com menos de 6 MB.",
  "reportBuilder.imageUrlPlaceholder": "URL da imagem (opcional)",
  "reportBuilder.includeLogo": "Incluir o logotipo da GuardAI",
  "reportBuilder.loadFailed": "Não foi possível carregar os dados.",
  "reportBuilder.lookAt": "Veja o {target}",
  "reportBuilder.maxRows": "Máx. de linhas",
  "reportBuilder.metric": "Métrica",
  "reportBuilder.moreSettings": "Mais configurações",
  "reportBuilder.moveDown": "Mover para baixo",
  "reportBuilder.moveUp": "Mover para cima",
  "reportBuilder.next": "Próximo",
  "reportBuilder.noDataSelection": "Nenhum dado para esta seleção",
  "reportBuilder.noImageUploaded": "Nenhuma imagem enviada",
  "reportBuilder.noLayout": "Não consegui transformar isso em um layout — tente descrever as métricas e como agrupá-las.",
  "reportBuilder.noSummary": "Nenhum resumo gerado.",
  "reportBuilder.noWidgetsYet": "Este relatório ainda não tem widgets.",
  "reportBuilder.optionalSubtitle": "Subtítulo opcional",
  "reportBuilder.orientation": "Orientação",
  "reportBuilder.period": "Período: {range}",
  "reportBuilder.preparedBy": "Preparado por {name}",
  "reportBuilder.preview": "Pré-visualização",
  "reportBuilder.previewHint": "É assim que seu relatório será exportado e impresso. Use o botão Exportar acima para baixar.",
  "reportBuilder.regenerate": "Regenerar",
  "reportBuilder.remove": "Remover",
  "reportBuilder.removeImage": "Remover imagem",
  "reportBuilder.reportImage": "Imagem do relatório",
  "reportBuilder.reportTitle": "Título do relatório",
  "reportBuilder.reportsAnalytics": "Relatórios e análises",
  "reportBuilder.saveAsTemplate": "Salvar o relatório atual como modelo compartilhado",
  "reportBuilder.savedAt": "Salvo às {time}",
  "reportBuilder.savedReports": "Relatórios salvos",
  "reportBuilder.secondSeriesLabel": "Rótulo da segunda série",
  "reportBuilder.secondSeriesMetric": "Métrica da segunda série",
  "reportBuilder.secondSeriesSource": "Fonte da segunda série",
  "reportBuilder.selectWidget": "Selecione um widget para configurá-lo.",
  "reportBuilder.seriesB": "Série B",
  "reportBuilder.sketch": "Esboço",
  "reportBuilder.sketchAlt": "esboço",
  "reportBuilder.sort": "Ordenar",
  "reportBuilder.sortLabelAsc": "Nome, A → Z",
  "reportBuilder.sortLabelDesc": "Nome, Z → A",
  "reportBuilder.sortValueAsc": "Valor, do menor ao maior",
  "reportBuilder.sortValueDesc": "Valor, do maior ao menor",
  "reportBuilder.startFromTemplate": "Começar a partir de um modelo",
  "reportBuilder.startNewReport": "Iniciar um novo relatório",
  "reportBuilder.stepOf": "Etapa {n} de {total}",
  "reportBuilder.subtitle": "Subtítulo",
  "reportBuilder.summaryFailed": "Falha ao gerar o resumo.",
  "reportBuilder.targetAiBar": "barra do assistente de IA",
  "reportBuilder.targetCanvas": "tela do relatório",
  "reportBuilder.targetConfigPanel": "painel de configuração",
  "reportBuilder.targetDataFields": "painel de campos de dados",
  "reportBuilder.targetExport": "botão de exportar",
  "reportBuilder.targetPreview": "alternador de pré-visualização",
  "reportBuilder.targetSave": "botão de salvar",
  "reportBuilder.targetTemplates": "botão de modelos",
  "reportBuilder.targetToolbar": "barra de ferramentas de widgets",
  "reportBuilder.templates": "Modelos",
  "reportBuilder.textPlaceholder": "Escreva seu texto. Use ## para um título e **negrito** para destaque.",
  "reportBuilder.thinking": "Pensando…",
  "reportBuilder.title": "Construtor de relatórios",
  "reportBuilder.total": "Total",
  "reportBuilder.try": "Experimente:",
  "reportBuilder.untitledReport": "Relatório sem título",
  "reportBuilder.uploadSketchTitle": "Envie uma foto de um layout de relatório desenhado à mão",
  "reportBuilder.vertical": "vertical",
  "reportBuilder.walkMeThrough": "Mostre-me passo a passo",
  "reportBuilder.widgetCountMany": "{n} widgets",
  "reportBuilder.widgetCountOne": "{n} widget",
  "reportBuilder.width": "Largura",
  "reportBuilder.widthFull": "Total",
  "reportBuilder.working": "Processando…",
  "reports.activeGuards": "Guardas ativos",
  "reports.asOfTime": "(às {time})",
  "reports.averageCompliance": "Conformidade média",
  "reports.averageResponseTime": "Tempo médio de resposta",
  "reports.checkpointLocationAnalysis": "Análise de locais dos pontos de verificação",
  "reports.checkpointsCompleted": "Pontos de verificação concluídos",
  "reports.checkpointsLoggedGps": "({n} pontos de verificação registados a partir de dados GPS)",
  "reports.colCompliance": "Conformidade",
  "reports.colPerformance": "Desempenho",
  "reports.compliance90to94": "90-94% de conformidade",
  "reports.compliance95": "≥95% de conformidade",
  "reports.complianceBelow90": "<90% de conformidade",
  "reports.complianceLabel": "conformidade",
  "reports.complianceReport": "Relatório de conformidade",
  "reports.coverageComplianceHelp": "% de pontos de verificação visitados pelo menos uma vez neste período",
  "reports.coverageComplianceTrends": "Tendências de conformidade de cobertura",
  "reports.criticalIssuesResolved": "Problemas críticos resolvidos",
  "reports.currentTime": "Atual: {time}",
  "reports.dayFri": "Sex",
  "reports.dayFriday": "Sexta-feira",
  "reports.dayMon": "Seg",
  "reports.dayMonday": "Segunda-feira",
  "reports.daySat": "Sáb",
  "reports.daySaturday": "Sábado",
  "reports.daySun": "Dom",
  "reports.daySunday": "Domingo",
  "reports.dayThu": "Qui",
  "reports.dayThursday": "Quinta-feira",
  "reports.dayTue": "Ter",
  "reports.dayTuesday": "Terça-feira",
  "reports.dayWed": "Qua",
  "reports.dayWednesday": "Quarta-feira",
  "reports.deltaLastMonth": "+1,8% em relação ao mês passado",
  "reports.deltaLastQuarter": "+3,2% em relação ao trimestre passado",
  "reports.deltaLastWeek": "+2,1% em relação à semana passada",
  "reports.deltaYesterday": "+1,5% em relação a ontem",
  "reports.downloadReport": "Baixar relatório",
  "reports.exceptions": "Exceções",
  "reports.exportFormat": "Formato de exportação",
  "reports.exportReport": "Exportar relatório",
  "reports.guardPerformanceAnalysis": "Análise de desempenho dos guardas",
  "reports.heatmapCellTitle": "{location} - {label}: {pct}% de atividade",
  "reports.lessActivity": "Menos atividade",
  "reports.loadingPatrolActivity": "Carregando atividade de patrulha…",
  "reports.locationAbbreviations": "Abreviações de locais:",
  "reports.locationActivityHeatmap": "Mapa de calor de atividade por local",
  "reports.missedCheckpoints": "Pontos de verificação perdidos",
  "reports.missedCount": "{n} perdidos",
  "reports.monFeb": "Fev",
  "reports.monJan": "Jan",
  "reports.monMar": "Mar",
  "reports.monthN": "Mês {n}",
  "reports.moreActivity": "Mais atividade",
  "reports.noChange": "Sem alteração",
  "reports.noCoverageData": "Ainda sem dados de cobertura",
  "reports.noDataForPeriod": "Sem dados para o período",
  "reports.noScanLocations": "Nenhum local de leitura de QR code disponível",
  "reports.notAvailable": "N/D",
  "reports.overallComplianceRate": "Taxa de conformidade geral",
  "reports.patrolLocations": "Locais de patrulha",
  "reports.periodMonth": "Este mês",
  "reports.periodQuarter": "Este trimestre",
  "reports.periodToday": "Hoje",
  "reports.periodWeek": "Esta semana",
  "reports.popupCompliance": "Conformidade:",
  "reports.popupLast": "Último:",
  "reports.popupScans": "Leituras:",
  "reports.qrScanLocations": "Locais de leitura de QR code",
  "reports.quickExportOptions": "Opções de exportação rápida",
  "reports.realScanData": "Dados de leitura reais (últimas 24h)",
  "reports.scanToSeeLocations": "Leia QR codes para ver os locais no mapa",
  "reports.scansCount": "{n} leituras",
  "reports.scansThisMonth": "{n} leituras este mês",
  "reports.scansThisQuarter": "{n} leituras este trimestre",
  "reports.scansThisWeek": "{n} leituras esta semana",
  "reports.scansToday": "{n} leituras hoje",
  "reports.tabCompliance": "Conformidade",
  "reports.tabGuardPerformance": "Desempenho dos guardas",
  "reports.tabLocationAnalysis": "Análise de locais",
  "reports.tabOverview": "Visão geral",
  "reports.totalScans": "Total de leituras",
  "reports.trackingLocationsGuards": "Acompanhando {locations} locais e {guards} guardas.",
  "reports.trendDaily": "Tendências de desempenho diárias",
  "reports.trendHourly": "Tendências de desempenho por hora",
  "reports.trendMonthly": "Tendências de desempenho mensais",
  "reports.trendTooltip": "{pct}% ({n} locais)",
  "reports.trendWeekly": "Tendências de desempenho semanais",
  "reports.validated": "Validados",
  "reports.viewDetails": "Ver detalhes",
  "reports.weekN": "Semana {n}",
  "reports.weeklySummary": "Resumo semanal",
  "reports.wk1": "Sem1",
  "reports.wk2": "Sem2",
  "reports.wk3": "Sem3",
  "reports.wk4": "Sem4",
  "schedules.activeRoutes": "Rotas ativas",
  "schedules.activeSchedules": "Agendas ativas",
  "schedules.addNewSchedule": "Adicionar nova agenda",
  "schedules.addSchedule": "Adicionar agenda",
  "schedules.assignedGuard": "Guarda atribuído",
  "schedules.assignedGuards": "Guardas atribuídos",
  "schedules.calendar": "Calendário",
  "schedules.confirmDelete": "Tem certeza de que deseja excluir esta agenda?",
  "schedules.coverageGaps": "Lacunas de cobertura",
  "schedules.createSchedule": "Criar agenda",
  "schedules.dayFri": "Sex",
  "schedules.dayMon": "Seg",
  "schedules.daySat": "Sáb",
  "schedules.daySun": "Dom",
  "schedules.dayThu": "Qui",
  "schedules.dayTue": "Ter",
  "schedules.dayWed": "Qua",
  "schedules.daysOfWeek": "Dias da semana",
  "schedules.deleteSchedule": "Excluir agenda",
  "schedules.editSchedule": "Editar agenda",
  "schedules.endTime": "Hora de término",
  "schedules.fillRequired": "Por favor, preencha todos os campos obrigatórios",
  "schedules.frequency": "Frequência",
  "schedules.frequencyCustom": "Personalizada",
  "schedules.frequencyDaily": "Diária",
  "schedules.frequencyWeekly": "Semanal",
  "schedules.listView": "Visualização em lista",
  "schedules.morningPatrol": "Patrulha matinal",
  "schedules.nightShift": "Turno noturno",
  "schedules.route": "Rota",
  "schedules.scheduleName": "Nome da agenda",
  "schedules.scheduleNamePlaceholder": "ex.: Patrulha matinal - Edifício A",
  "schedules.selectGuard": "Selecione um guarda",
  "schedules.selectRoute": "Selecione uma rota",
  "schedules.selectedCount": "Selecionados: {n} ponto(s) de verificação",
  "schedules.startTime": "Hora de início",
  "schedules.updateSchedule": "Atualizar agenda",
  "settings.browserDesc": "UA registrado para monitorar a integridade do dispositivo.",
  "settings.browserLabel": "Navegador",
  "settings.cameraDesc": "Necessário para ler etiquetas QR. Ajuste nas configurações do sistema se for negada.",
  "settings.cameraPermission": "Permissão da câmera",
  "settings.deviceIdDesc": "Impressão digital armazenada a cada leitura para conformidade de auditoria.",
  "settings.deviceIdLabel": "ID do dispositivo",
  "settings.email": "E-mail",
  "settings.escalationAlerts": "Alertas de escalonamento",
  "settings.fullName": "Nome completo",
  "settings.installPwa": "Instalar como PWA",
  "settings.locationDesc": "Necessário para verificação por GPS em cada ponto de controle.",
  "settings.locationPermission": "Permissão de localização",
  "settings.mobilePhone": "Telefone celular",
  "settings.notRegistered": "Ainda não registrado",
  "settings.notificationDesc": "Controle quais alertas a equipe de supervisão pode enviar para você.",
  "settings.notificationPreferences": "Preferências de notificação",
  "settings.permGranted": "Concedido",
  "settings.permUnknown": "Desconhecido",
  "settings.profileDetails": "Detalhes do perfil",
  "settings.profileSavedMsg": "Preferências do perfil salvas. As alterações entram em vigor imediatamente.",
  "settings.pwaAndroid": "Android (Chrome):",
  "settings.pwaAndroidSteps": "Menu → Instalar app.",
  "settings.pwaDesktop": "Desktop:",
  "settings.pwaDesktopSteps": "Use o aviso de instalação do navegador na barra de endereços.",
  "settings.pwaIos": "iOS (Safari):",
  "settings.pwaIosSteps": "Toque em Compartilhar → Adicionar à Tela de Início.",
  "settings.saveProfile": "Salvar perfil",
  "settings.storedLocally": "As configurações são armazenadas localmente até que a sincronização de perfil esteja disponível.",
  "settings.weeklyEmailSummary": "Resumo semanal por e-mail",
  "users.applicationDetails": "Detalhes da candidatura",
  "users.applicationReview": "Revisão da candidatura:",
  "users.applicationStatus": "Status da candidatura",
  "users.approve": "Aprovar",
  "users.approveApplication": "Aprovar candidatura",
  "users.backToApplications": "Voltar às candidaturas",
  "users.colApplicant": "Candidato",
  "users.colRole": "Função",
  "users.dateAdded": "Data de adição",
  "users.directoryFound": "Encontrado na tabela employees_personal_info.",
  "users.directoryMatch": "Correspondência no diretório",
  "users.directoryName": "Nome no diretório",
  "users.email": "E-mail",
  "users.filterAll": "Todas as candidaturas",
  "users.filterPending": "Aguardando revisão",
  "users.nextSteps": "Próximos passos",
  "users.noApplications": "Nenhuma candidatura encontrada",
  "users.phone": "Telefone",
  "users.phoneNumber": "Número de telefone",
  "users.reject": "Rejeitar",
  "users.rejectApplication": "Rejeitar candidatura",
  "users.requestedRole": "Função solicitada",
  "users.review": "Revisar",
  "users.statusRejected": "Rejeitado",
  "users.stepBackgroundCheck": "Iniciar verificação de antecedentes",
  "users.stepCheckLicense": "Verificar a validade da licença/certificação",
  "users.stepScheduleInterview": "Agendar entrevista se aprovado",
  "users.stepVerifyReferences": "Verificar referências por telefone",
  "users.submitted": "Enviado:",
  "widget.aiSummary": "Resumo com IA",
  "widget.barChart": "Gráfico de barras",
  "widget.comparison": "Comparação",
  "widget.dataTable": "Tabela de dados",
  "widget.dayOfWeek": "Dia da semana",
  "widget.image": "Imagem",
  "widget.kpiRow": "Linha de KPI",
  "widget.lineChart": "Gráfico de linhas",
  "widget.metricCard": "Cartão de métrica",
  "widget.pieDonut": "Pizza / Rosca",
  "widget.rankedTable": "Tabela classificada",
  "widget.textBlock": "Bloco de texto",

  // Activity calendar
  "calendar.title": "Calendário de atividade de patrulha",
  "calendar.subtitle": "Atividade de leitura em cada ponto de controle, dia a dia",
  "calendar.viewMonth": "Mês",
  "calendar.viewWeek": "Semana",
  "calendar.viewDay": "Dia",
  "calendar.viewList": "Lista",
  "calendar.today": "Hoje",
  "calendar.allHospitals": "Todos os hospitais",
  "calendar.totalScans": "{n} leituras",
  "calendar.activeDays": "{n} dias ativos",
  "calendar.alertsCount": "{n} alertas",
  "calendar.noActivityRange": "Nenhuma atividade de leitura neste período.",
  "calendar.loading": "Carregando atividade…",
  "calendar.loadFailed": "Falha ao carregar atividade",
  "calendar.refresh": "Atualizar",
  "calendar.colTime": "Hora",
  "calendar.colHospital": "Hospital",
  "calendar.colCheckpoint": "Ponto de controle",
  "calendar.colDevice": "Dispositivo",
  "calendar.colGuard": "Guarda",
  "calendar.violation": "Violação",
  "calendar.violationsCount": "{n} violações",
  "calendar.scansShort": "{n} leituras",
  "calendar.hospitalsActive": "{n} hospitais ativos",
  "calendar.moreEvents": "+{n} mais",
  "calendar.weekOf": "Semana de {date}",
  "calendar.dayEvents": "Eventos de leitura",
  "calendar.hourlyDistribution": "Distribuição por hora",
  "calendar.legendLess": "Menos",
  "calendar.legendMore": "Mais",
  "calendar.unknownHospital": "Hospital desconhecido",
  "calendar.unknownGuard": "Guarda desconhecido",
  "calendar.unknownCheckpoint": "Ponto de controle desconhecido",

  // --- Synced from en.ts: newer pages (officers, compliance, checkpoints, patrol reports) ---
  "nav.compliance": "Conformidade",
  "nav.officers": "Agentes",
  "nav.patrolReports": "Relatórios de Ronda",
  "common.retry": "Tentar novamente",
  "common.collapse": "Recolher",
  "common.expand": "Expandir",
  "home.comparisonVsMapNote": "As contagens incluem todas as leituras registradas. O Mapa de Leituras exibe apenas leituras com coordenadas de GPS, portanto seu total pode ser menor.",
  "live.colOfficer": "Agente",
  "live.unattributed": "Não atribuído",
  "map.trailNote": "Os pontos são coloridos pelo horário da leitura. Nenhum caminho entre as leituras é traçado — apenas os locais de leitura registrados são exibidos.",
  "checkpoints.directoryTitle": "Diretório de Pontos de Controle",
  "checkpoints.directorySubtitle": "Todos os pontos de controle QR registrados, organizados por andar",
  "checkpoints.searchPlaceholder": "Pesquisar por nome, código ou edifício…",
  "checkpoints.countShown": "{n} pontos de controle",
  "checkpoints.exportCsv": "Exportar CSV",
  "checkpoints.loadingDirectory": "Carregando pontos de controle…",
  "checkpoints.empty": "Nenhum ponto de controle encontrado para este hospital.",
  "checkpoints.noFloor": "Não atribuído",
  "checkpoints.floorLabel": "Andar {n}",
  "checkpoints.colCode": "Código",
  "checkpoints.colName": "Nome",
  "checkpoints.colBuilding": "Edifício",
  "checkpoints.colFloor": "Andar",
  "checkpoints.colLastScanned": "Última leitura",
  "checkpoints.colTotalScans": "Total de Leituras",
  "checkpoints.colStatus": "Status",
  "checkpoints.active": "Ativo",
  "checkpoints.inactive": "Inativo",
  "checkpoints.never": "Nunca",
  "checkpoints.untitled": "Ponto de controle sem título",
  "checkpoints.totalScans": "Total de Leituras",
  "checkpoints.compliance": "Conformidade",
  "checkpoints.late": "Atrasado",
  "checkpoints.missed": "Não verificado",
  "checkpoints.fromDate": "De",
  "checkpoints.toDate": "Até",
  "checkpoints.clearDates": "Limpar",
  "checkpoints.loadingHistory": "Carregando histórico de leituras…",
  "checkpoints.noScans": "Nenhuma leitura registrada para este ponto de controle no período selecionado.",
  "checkpoints.unknownDevice": "Dispositivo desconhecido",
  "checkpoints.noGps": "Sem GPS",
  "checkpoints.statusOnTime": "No horário",
  "checkpoints.statusLate": "Atrasado",
  "checkpoints.statusMissed": "Não verificado",
  "checkpoints.viewHistory": "Ver histórico de leituras",
  "compliance.title": "Conformidade de Ronda",
  "compliance.subtitle": "Status de leitura dos pontos de controle em relação ao intervalo configurado de cada local.",
  "compliance.advisory": "Apenas informativo. Esta visão indica quando cada ponto de controle foi lido pela última vez e o tempo restante em seu intervalo de leitura. Não é uma atribuição de trabalho, uma rota ou uma instrução. Quais pontos de controle são lidos e em que ordem permanecem decisão do agente e de seu supervisor, sujeitos às ordens de serviço do empregador e a quaisquer tarefas de maior prioridade.",
  "compliance.loadFailed": "Não foi possível carregar o status de conformidade",
  "compliance.overdue": "Atrasado",
  "compliance.overdueSub": "Após o intervalo de leitura",
  "compliance.dueSoon": "Vence em breve",
  "compliance.dueSoonSub": "No último quarto do intervalo",
  "compliance.onInterval": "No intervalo",
  "compliance.onIntervalSub": "Lido dentro do intervalo",
  "compliance.neverScanned": "Sem leitura registrada",
  "compliance.neverScannedSub": "Não contabilizado como atrasado",
  "compliance.neverScannedNoteTitle": "Por que estes não são contabilizados como atrasados:",
  "compliance.neverScannedNote": "Um ponto de controle sem leitura registrada não tem intervalo que possa ter sido excedido. Pontos de controle anteriores ao monitoramento de conformidade aparecem assim até que o preenchimento histórico seja executado para o hospital, portanto tratá-los como atrasados geraria um alerta para todos os pontos de controle de uma só vez.",
  "compliance.openAlerts": "Alertas de conformidade abertos",
  "compliance.checkpointStatus": "Status dos pontos de controle",
  "compliance.filterAttention": "Atrasados e vencendo em breve",
  "compliance.filterOverdue": "Apenas atrasados",
  "compliance.filterAll": "Todos os pontos de controle",
  "compliance.emptyAll": "Nenhum ponto de controle encontrado para esta seleção.",
  "compliance.emptyAttention": "Nenhum ponto de controle está atrasado ou vencendo em breve.",
  "compliance.colCheckpoint": "Ponto de controle",
  "compliance.colStatus": "Status",
  "compliance.colLastScan": "Última leitura",
  "compliance.colInterval": "Intervalo",
  "compliance.colRemaining": "Tempo no intervalo",
  "compliance.colScans24h": "Leituras (24h)",
  "compliance.status.OVERDUE": "Atrasado",
  "compliance.status.DUE_SOON": "Vence em breve",
  "compliance.status.OK": "No intervalo",
  "compliance.status.NEVER_SCANNED": "Sem leitura registrada",
  "compliance.minutesShort": "min",
  "compliance.perDay": "por dia",
  "compliance.ruleLocation": "regra do local",
  "compliance.ruleHospital": "padrão do hospital",
  "compliance.truncated": "Exibindo apenas os resultados mais urgentes. Restrinja por hospital para ver o restante.",
  "compliance.generatedAt": "Status em",
  "compliance.rules": "Intervalos de Leitura",
  "compliance.rulesTitle": "Intervalos de Leitura",
  "compliance.rulesSubtitle": "Uma regra do local prevalece sobre o padrão do hospital, que prevalece sobre o padrão do sistema.",
  "compliance.rulesEmpty": "Nenhuma regra personalizada — aplica-se o padrão do sistema.",
  "compliance.rulesLoadFailed": "Não foi possível carregar as regras",
  "compliance.rulesSaveFailed": "Não foi possível salvar a regra",
  "compliance.rulesDeleteFailed": "Não foi possível excluir a regra",
  "compliance.rulesCreateFailed": "Não foi possível criar a regra",
  "compliance.rulesInvalid": "O intervalo e o mínimo diário devem ser números",
  "compliance.systemDefault": "Padrão do sistema",
  "compliance.systemDefaultValue": "a cada",
  "compliance.systemDefaultNote": "Hospitais sem regra própria são avaliados por este.",
  "compliance.siteWide": "Todos os pontos de controle deste hospital",
  "compliance.colAppliesTo": "Aplica-se a",
  "compliance.colIntervalMin": "Intervalo (min)",
  "compliance.colMinPerDay": "Mín / 24h",
  "compliance.colActions": "Ações",
  "compliance.addSiteDefault": "Adicionar padrão do hospital",
  "compliance.pickSiteToAdd": "Selecione um único hospital para adicionar um padrão a ele.",
  "officers.title": "Agentes",
  "officers.subtitle": "Agentes que entram em serviço com um número N para que suas leituras sejam atribuídas. Estes não são logins do painel.",
  "officers.add": "Adicionar agente",
  "officers.addTitle": "Adicionar agente",
  "officers.editTitle": "Editar agente",
  "officers.loadFailed": "Não foi possível carregar os agentes",
  "officers.saveFailed": "Não foi possível salvar o agente",
  "officers.deactivateFailed": "Não foi possível desativar o agente",
  "officers.searchPlaceholder": "Pesquisar por nome, número N ou e-mail",
  "officers.filterActive": "Ativo",
  "officers.filterInactive": "Inativo",
  "officers.filterSuspended": "Suspenso",
  "officers.filterPending": "Aguardando aprovação",
  "officers.filterRejected": "Rejeitado",
  "officers.filterAll": "Todos os status",
  "officers.onShiftCount": "Atualmente em serviço:",
  "officers.empty": "Ainda não há agentes. Adicione um para começar a atribuir leituras.",
  "officers.emptySearch": "Nenhum agente corresponde a essa pesquisa.",
  "officers.colOfficer": "Agente",
  "officers.colNNumber": "Número N",
  "officers.colSite": "Hospital",
  "officers.colStatus": "Status",
  "officers.colShift": "Turno atual",
  "officers.colActions": "Ações",
  "officers.status.ACTIVE": "Ativo",
  "officers.status.PENDING": "Aguardando aprovação",
  "officers.status.INACTIVE": "Inativo",
  "officers.status.SUSPENDED": "Suspenso",
  "officers.status.REJECTED": "Rejeitado",
  "officers.onShiftSince": "Em serviço desde",
  "officers.offShift": "Fora de serviço",
  "officers.scans": "leituras",
  "officers.deactivate": "Desativar",
  "officers.deactivateTitle": "Desativar agente?",
  "officers.deactivateBody": "{name} não poderá mais entrar em serviço, e qualquer turno aberto será encerrado. Seu histórico de leituras é mantido e permanece atribuído a ele.",
  "officers.fieldNNumber": "Número N",
  "officers.fieldNNumberHint": "O N inicial é adicionado automaticamente se você omiti-lo.",
  "officers.fieldName": "Nome completo",
  "officers.fieldSite": "Hospital",
  "officers.fieldEmail": "E-mail",
  "officers.fieldPhone": "Telefone",
  "officers.fieldStatus": "Status",
  "officers.fieldStatusHint": "Apenas agentes ATIVOS podem entrar em serviço. Alterar para um status diferente de ATIVO encerra qualquer turno aberto.",
  "officers.selectSite": "Selecione um hospital",
  "officers.formRequired": "Número N, nome e hospital são obrigatórios",
  "officers.pendingTitle": "Aprovações de cadastro pendentes",
  "officers.selfEnrolled": "Autocadastrado",
  "officers.enrolledAt": "entrou em serviço",
  "officers.enrollDistance": "{d} da área de leitura registrada do hospital",
  "officers.enrollNoGps": "sem sinal de GPS ao entrar em serviço",
  "officers.enrollSiteMismatch": "Selecionou {chosen}, mas o GPS apontou para {gps} — confirme qual está correto antes de aprovar.",
  "officers.pendingNote": "Estas identidades foram autoinformadas em uma leitura de crachá. Suas leituras são atribuídas provisoriamente até a aprovação; a rejeição mantém o registro e suas leituras para revisão.",
  "officers.approve": "Aprovar",
  "officers.reject": "Rejeitar",
  "officers.approveTitle": "Aprovar cadastro?",
  "officers.approveBody": "Confirma {n} como agente em {site}. Suas leituras pendentes permanecem atribuídas e os próximos registros de entrada em serviço funcionam normalmente.",
  "officers.approveName": "Nome do agente (como deve aparecer)",
  "officers.approveFailed": "Não foi possível aprovar o cadastro",
  "officers.rejectFailed": "Não foi possível rejeitar o cadastro",
  "patrolReports.title": "Relatórios de Ronda",
  "patrolReports.subtitle": "Atividade de ronda registrada por agente, cobertura de pontos de controle e histórico de alertas de conformidade.",
  "patrolReports.tabOfficers": "Agentes",
  "patrolReports.tabCoverage": "Cobertura",
  "patrolReports.tabHistory": "Histórico de alertas",
  "patrolReports.loadFailed": "Não foi possível carregar o relatório",
  "patrolReports.badRange": "A data de início deve ser igual ou anterior à data de término",
  "patrolReports.startDate": "Data de início",
  "patrolReports.endDate": "Data de término",
  "patrolReports.totalScans": "Leituras no período",
  "patrolReports.attributed": "Atribuídas a um agente",
  "patrolReports.unattributed": "Não atribuídas",
  "patrolReports.unattributedSub": "Lidas enquanto nenhum agente estava em serviço",
  "patrolReports.officersListed": "Agentes listados",
  "patrolReports.noOfficers": "Nenhum agente nesta seleção.",
  "patrolReports.colOfficer": "Agente",
  "patrolReports.colSite": "Hospital",
  "patrolReports.colShifts": "Turnos",
  "patrolReports.colShiftTime": "Tempo de turno",
  "patrolReports.colScans": "Leituras",
  "patrolReports.colCheckpoints": "Pontos de controle",
  "patrolReports.colScansHr": "Leituras / h",
  "patrolReports.colLastScan": "Última leitura",
  "patrolReports.fullyCovered": "Coberto todos os dias",
  "patrolReports.partiallyCovered": "Coberto em alguns dias",
  "patrolReports.uncovered": "Nenhuma leitura no período",
  "patrolReports.of": "de",
  "patrolReports.coverageTitle": "Cobertura dos pontos de controle",
  "patrolReports.coverageSort": "Pontos de controle menos cobertos primeiro.",
  "patrolReports.colCheckpoint": "Ponto de controle",
  "patrolReports.colDaysCovered": "Dias cobertos",
  "patrolReports.colExpected": "Esperado",
  "patrolReports.colStatusNow": "Status atual",
  "patrolReports.alertsRaised": "Alertas no período",
  "patrolReports.alertsOpen": "Ainda abertos",
  "patrolReports.alertsResolved": "Resolvidos",
  "patrolReports.repeatTitle": "Pontos de controle que mais geram alertas",
  "patrolReports.colAlerts": "Alertas",
  "patrolReports.colOpen": "Abertos",
  "patrolReports.colWorst": "Maior atraso",
  "patrolReports.colAvgResolve": "Tempo médio de resolução",
  "patrolReports.colLatest": "Mais recente",
  "patrolReports.alertLog": "Registro de alertas",
  "patrolReports.noAlerts": "Nenhum alerta neste período.",
  "patrolReports.resolvedIn": "resolvido em",
  "patrolReports.stateResolved": "Resolvido",
  "patrolReports.stateOpen": "Aberto",
  "emailPrefs.title": "Preferências de alertas por e-mail",
  "emailPrefs.subtitle": "Escolha quais e-mails de conformidade você recebe, por hospital.",
  "emailPrefs.loadFailed": "Não foi possível carregar as preferências de e-mail",
  "emailPrefs.saveFailed": "Não foi possível salvar a preferência",
  "emailPrefs.noSites": "Nenhum hospital na sua lista de acesso.",
  "emailPrefs.noPreference": "Nenhuma preferência salva — aplica-se o padrão",
  "emailPrefs.explainer": "Hospitais onde ninguém salvou uma preferência recorrem ao envio de e-mail para todos os supervisores e diretores. Salvar qualquer preferência em um hospital passa a usar apenas as escolhas explícitas.",
  "emailPrefs.overdue": "Alertas de atraso",
  "emailPrefs.overdueHint": "E-mail imediato quando os pontos de controle ultrapassam seu intervalo de leitura",
  "emailPrefs.daily": "Resumo diário",
  "emailPrefs.dailyHint": "Um resumo de conformidade por dia",
  "emailPrefs.officerSummary": "Resumo de atividade dos agentes",
  "emailPrefs.officerSummaryHint": "Relatório semanal de atividade registrada. Desativado, a menos que você opte por recebê-lo.",
  "emailPrefs.manageOthers": "Gerenciar destinatários neste hospital",
  "emailPrefs.noOthers": "Nenhum outro destinatário configurado aqui.",
  "emailPrefs.enrollEmail": "email@emoryhealthcare.org",
  "emailPrefs.enrollName": "Nome (opcional)",
  "emailPrefs.enroll": "Adicionar destinatário",
  "emailPrefs.officerSummaryNote": "O resumo de atividade dos agentes é um relatório programado da atividade de leitura registrada, com suas ressalvas incluídas — não é uma avaliação de desempenho e nunca é enviado a quem não optou por recebê-lo.",
  "officerMap.open": "Ver mapa do histórico de leituras",
  "officerMap.title": "Histórico de leituras",
  "officerMap.loadFailed": "Não foi possível carregar o histórico de leituras",
  "officerMap.empty": "Nenhuma leitura com marcação de GPS atribuída a este agente no período selecionado.",
  "officerMap.firstScan": "Primeira leitura",
  "officerMap.lastScan": "Última leitura",
  "officerMap.scans": "leituras",
  "officerMap.ofTotal": "de {n} leituras",
  "officerMap.note": "Apenas as leituras atribuídas a este agente aparecem aqui. Leituras feitas fora de serviço não são atribuídas e não são exibidas.",
  "patrolReports.officersTableTitle": "Atividade registrada por agente",


  // --- Officer detail page (synced from en.ts) ---
  "officerDetail.allOfficers": "Todos os agentes",
  "officerDetail.backToOfficers": "Voltar aos agentes",
  "officerDetail.notFound": "Agente não encontrado.",
  "officerDetail.loadFailed": "Não foi possível carregar o agente",
  "officerDetail.selfEnrolled": "Autocadastrado",
  "officerDetail.addedBySupervisor": "Adicionado pelo supervisor",
  "officerDetail.memberSince": "membro desde {date}",
  "officerDetail.totalScans": "Total de leituras",
  "officerDetail.shifts": "Turnos",
  "officerDetail.activeDays": "Dias ativos",
  "officerDetail.avgShift": "Média / turno",
  "officerDetail.noShiftsYet": "ainda sem turnos",
  "officerDetail.scansPerShift": "leituras por turno",
  "officerDetail.lastActive": "Última atividade",
  "officerDetail.whereScanned": "Onde {name} leu",
  "officerDetail.mapToLight": "Mudar o mapa para blocos claros",
  "officerDetail.mapToDark": "Mudar o mapa para blocos escuros",
  "officerDetail.light": "Claro",
  "officerDetail.dark": "Escuro",
  "officerDetail.noGpsScans": "Nenhuma leitura com marcação de GPS para exibir no mapa nos últimos 30 dias.",
  "officerDetail.scanActivityTitle": "Atividade de leitura — Últimos {n} dias",
  "officerDetail.noScansInDays": "Nenhuma leitura registrada nos últimos {n} dias.",
  "officerDetail.scanHistory": "Histórico de leituras",
  "officerDetail.searchScans": "Pesquisar leituras…",
  "officerDetail.colDateTime": "Data e hora",
  "officerDetail.colLocation": "Local",
  "officerDetail.colHospital": "Hospital",
  "officerDetail.colCoordinates": "Coordenadas",
  "officerDetail.noScansMatch": "Nenhuma leitura corresponde a “{q}”.",
  "officerDetail.showingScans": "Exibindo {shown} de {total} leituras registradas (últimos 30 dias).",
  "officerDetail.timelineRange": "{n} leituras · mais antigas → mais recentes",
  "officerDetail.hoverTimeline": "Passe o cursor sobre a linha do tempo para rastrear uma leitura",
  "officerDetail.timelineCaption": "Cada ponto é uma leitura, posicionada pelo momento em que ocorreu e colorida do azul (mais antiga) ao vermelho (mais recente). Passe o cursor para destacá-la no mapa. Nenhum caminho entre as leituras é traçado — apenas os locais de leitura registrados são exibidos.",


  // --- Scan Map anomaly/misplaced views (synced from en.ts) ---
  "map.officer": "Agente",
  "map.clearOfficer": "Limpar filtro de agente",
  "map.searchOfficer": "Pesquisar agente…",
  "map.misplacedTitle": "Mostrar apenas leituras cujo GPS ficou a mais de 1 km de seu ponto de controle",
  "map.misplacedOn": "Fora do local",
  "map.misplacedOff": "Fora do local",
  "map.anomaliesTitle": "Mostrar leituras sinalizadas como anômalas — deslocamento impossível do agente ou leitura posicionada longe de seu próprio hospital",
  "map.anomalies": "Anomalias",
  "map.popupOfficer": "Agente:",
  "map.anomalousMovement": "Anômala — deslocamento impossível entre as leituras deste agente",
  "map.anomalousHospital": "Anômala — posicionada longe do hospital indicado",
  "map.anomalousBoth": "Anômala — deslocamento impossível e distante de seu hospital",
  "map.metersFromCheckpoint": "{n} m de seu ponto de controle",
  "map.scansLabel": "leituras",
  "map.earliest": "Mais antiga",
  "map.latest": "Mais recente",

};

export default pt;
